import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import { useCart } from '../contexts/CartContext';
import { toast } from 'sonner';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addToCart(product);
    toast.success(`${product.name} added to cart!`);
  };

  return (
    <motion.div
      whileHover={{ y: -4, boxShadow: '0 12px 24px rgba(59, 42, 35, 0.12)' }}
      className="card-flat overflow-hidden group"
      data-testid={`product-card-${product.id}`}
    >
      <div className="aspect-square overflow-hidden">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="p-6 space-y-4">
        <div className="flex flex-wrap gap-2">
          {product.tags.slice(0, 2).map((tag, index) => (
            <span
              key={index}
              className="overline text-[10px] bg-desert-sand px-2 py-1 rounded-md text-dark-cedar"
            >
              {tag}
            </span>
          ))}
        </div>
        <div>
          <h3 className="font-playfair text-xl font-semibold text-dark-cedar mb-1">
            {product.name}
          </h3>
          <p className="text-dark-cedar/60 text-sm line-clamp-2 leading-relaxed">
            {product.description}
          </p>
        </div>
        <div className="flex items-center justify-between pt-2">
          <div>
            <span className="font-inter text-2xl font-bold text-dark-cedar">
              ${product.price.toFixed(2)}
            </span>
            <span className="text-sm text-dark-cedar/60 ml-1">USD</span>
          </div>
          <Button
            onClick={handleAddToCart}
            className="bg-tiger-orange hover:bg-tiger-orange/90 text-soft-ivory rounded-full px-4"
            data-testid={`add-to-cart-${product.id}`}
          >
            <ShoppingCart className="w-4 h-4 mr-2" />
            Add
          </Button>
        </div>
      </div>
    </motion.div>
  );
}